import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "../../environments/environment";
import {
  BusinessLineOption,
  ConsumerSmsCampaignRequest,
  ConsumerSmsCampaignResult
} from "../models/consumer-sms-campaign.model";

/**
 * PURPOSE: responsible for triggering the consumer referral anniversary SMS campaign
 */
@Injectable({
  providedIn: "root"
})
export class ConsumerSmsCampaignService {
  constructor(private http: HttpClient) {}

  runCampaign(request: ConsumerSmsCampaignRequest): Observable<ConsumerSmsCampaignResult> {
    return this.http
      .post<ConsumerSmsCampaignResult>(
        `${environment.fulcrumUrl}/api/v3/consumer-sms-campaign/referral-anniversary`,
        request,
        this.buildBasicHttpOptions()
      )
      .pipe(
        catchError((error: HttpErrorResponse): Observable<never> => {
          console.error("Error running consumer SMS campaign:", error);
          return throwError(() => error);
        })
      );
  }

  getBusinessLines(): Observable<BusinessLineOption[]> {
    return this.http
      .get<
        BusinessLineOption[]
      >(`${environment.fulcrumUrl}/api/v3/consumer-sms-campaign/business-lines`, this.buildBasicHttpOptions())
      .pipe(
        catchError((error: HttpErrorResponse): Observable<never> => {
          console.error("Error fetching business lines:", error);
          return throwError(() => error);
        })
      );
  }

  private buildBasicHttpOptions() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization:
          "Basic " + btoa(`${environment.claimItApiUsername}:${environment.claimItApiPassword}`)
      })
    };
  }
}
